import React from 'react';
import { Link } from 'react-router';
import cn from 'classnames';
import { Button } from 'swag-client-common/components/ui/button';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { isPortraitOrientation, isTallScreen } from 'swag-client-common/utils/ui.utils';
import { SuperSpeedWidget } from '../../routes/client/product/components/super-speed-widget';
import BuildBoxWidget from '../../routes/client/product/components/build-box-widget';
import css from './gallery-hoc.scss';
export const GalleryHoc = ({
  showSuperSpeedWidget,
  showBuildBoxWidget,
  onSuperSpeedClick
}) => {
  const isScreenTall = isPortraitOrientation() || isTallScreen();
  return /*#__PURE__*/React.createElement("div", {
    className: css.gallery
  }, showSuperSpeedWidget && /*#__PURE__*/React.createElement(SuperSpeedWidget, {
    className: css.donateWidget,
    onClick: onSuperSpeedClick
  }), showBuildBoxWidget && /*#__PURE__*/React.createElement(BuildBoxWidget, {
    className: css.donateWidget
  }), /*#__PURE__*/React.createElement("div", {
    className: cn(css.container, {
      [css.tallScreen]: isScreenTall
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: css.video
  }), /*#__PURE__*/React.createElement("div", {
    className: css.content
  }, /*#__PURE__*/React.createElement("h1", {
    className: css.title
  }, "Swag Simplified."), /*#__PURE__*/React.createElement("div", {
    className: css.text
  }, "Your all-in one swag platform. Shop, store, and ship the highest ", /*#__PURE__*/React.createElement("br", null), ' ', "quality swag around the world with the click of a button."), /*#__PURE__*/React.createElement(Link, {
    to: APP_ROUTES.ALL_SWAG,
    className: css.buttonWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    dataButton: "Shop Products",
    type: "secondary",
    className: css.button
  }, "Shop Products"))), /*#__PURE__*/React.createElement("div", {
    className: css.mobileHero
  })));
};